import { addRawList, deleteRawAction, setRaw, setRaws } from '../../action/raw';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = [];

export default createReducer(
  [
    forAction(setRaws, identityPayload),
    forAction(setRaw, (state, { payload: good }) => {
      const index = state.findIndex((item) => item.id === good.id);
      const updated = [...state];
      updated[index] = { ...good };
      return updated;
    }),
    forAction(addRawList, (state, { payload: good }) => {
      const updated = [...state, good];
      return updated;
    }),
    forAction(deleteRawAction, (state, { payload: id }) => {
      return state.filter((item) => item.id !== id);
    })
  ],
  initialState,
);
